import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Leaf, CheckCircle2 } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { PasswordInput } from "../components/PasswordInput";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== password2) {
      setError("Şifreler eşleşmiyor");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F7F7F6] px-6">
      <div className="w-full max-w-sm fade-up">
        <div className="mb-8 flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center bg-[#1C4E35]">
            <Leaf size={18} className="text-[#8FD4AC]" />
          </div>
          <span className="font-heading text-base font-black tracking-tight">COP31 PORTAL</span>
        </div>
        {done ? (
          <div className="border border-stone-200 bg-white p-6" data-testid="reset-success">
            <CheckCircle2 size={32} className="text-[#1C4E35]" />
            <h1 className="font-heading mt-3 text-xl font-black tracking-tight">Şifreniz Güncellendi</h1>
            <p className="mt-2 text-sm text-stone-600">Yeni şifrenizle giriş yapabilirsiniz.</p>
            <Link to="/login">
              <Button className="mt-5 w-full rounded-sm bg-[#1C4E35] text-white hover:bg-[#143A26]" data-testid="reset-back-to-login">Giriş Yap</Button>
            </Link>
          </div>
        ) : !token ? (
          <div className="border border-red-300 bg-red-50 p-6 text-sm text-red-700" data-testid="reset-no-token">
            Geçersiz bağlantı. Lütfen e-postanızdaki bağlantıyı kullanın veya giriş sayfasından yeni bağlantı isteyin.
            <Link to="/login" className="mt-3 block font-medium text-[#1C4E35] hover:underline">Giriş sayfasına dön</Link>
          </div>
        ) : (
          <>
            <p className="text-xs uppercase tracking-[0.2em] text-stone-500">Şifre Sıfırlama</p>
            <h1 className="font-heading mt-2 text-3xl font-black tracking-tight text-[#0A0D0B]">Yeni Şifre Belirle</h1>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div className="space-y-1.5">
                <Label className="text-xs uppercase tracking-wider text-stone-600">Yeni Şifre</Label>
                <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)} testId="reset-password-input" />
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs uppercase tracking-wider text-stone-600">Yeni Şifre (Tekrar)</Label>
                <PasswordInput value={password2} onChange={(e) => setPassword2(e.target.value)} testId="reset-password2-input" />
              </div>
              {error && <p className="border border-red-300 bg-red-50 px-3 py-2 text-xs text-red-700" data-testid="reset-error">{error}</p>}
              <Button type="submit" disabled={loading} data-testid="reset-submit-button" className="w-full rounded-sm bg-[#1C4E35] text-white hover:bg-[#143A26] active:scale-95">
                {loading ? "Kaydediliyor..." : "Şifreyi Güncelle"}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
